module.exports = __webpack_public_path__ + "HTML5.62aa90.svg";